document.addEventListener('DOMContentLoaded', function() {
  // Duplicate marquee for seamless loop
  const track = document.querySelector('.marquee-track');
  if (track) {
    const clone = track.cloneNode(true);
    track.parentNode.appendChild(clone);
  }

  // Pause marquee on hover
  const marqueeBar = document.querySelector('.marquee-bar');
  if (marqueeBar) {
    marqueeBar.addEventListener('mouseenter', () => {
      document.querySelectorAll('.marquee-track').forEach(t => t.style.animationPlayState = 'paused');
    });
    marqueeBar.addEventListener('mouseleave', () => {
      document.querySelectorAll('.marquee-track').forEach(t => t.style.animationPlayState = 'running');
    });
  }

  // Sticky header shadow on scroll
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.borderBottomColor = window.scrollY > 10 ? 'rgba(255,255,255,0.15)' : 'rgba(255,255,255,0.08)';
    });
  }
});
